import styled from '@emotion/styled';
import {
  blueActiveColor,
  blueDisabledColor,
  blueEnabledColor,
  blueHoverColor,
  lightGrey,
  darkGrey,
  white,
  superLightGrey,
  appTextColor,
  mediumDarkGrey,
  lightestGrey
} from './colors';

export const LaunchpadButton = styled.div((props) => {
  let style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '20px',
    backgroundColor: blueEnabledColor,
    color: white,
    height: '40px',
    width: '100%',
    letterSpacing: '1px',
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: '400',
    cursor: 'pointer',
    outline: 'none',
    ':hover': {
      backgroundColor: blueHoverColor
    },
    ':hover:active': {
      backgroundColor: blueActiveColor
    },
    ':focus': {
      border: '1px solid ' + (props.disabled ? lightGrey : blueActiveColor)
    }
  };
  if (props.disabled) {
    style.backgroundColor = blueDisabledColor;
    style.pointerEvents = 'none';
  }
  return style;
});

export const WhiteLaunchpadButton = styled(LaunchpadButton)((props) => {
  let style = {
    backgroundColor: white,
    border: '1px solid ' + lightGrey,
    color: appTextColor,
    ':hover': {
      backgroundColor: white,
      borderColor: mediumDarkGrey
    },
    ':hover:active': {
      backgroundColor: superLightGrey,
      borderColor: darkGrey
    },
    ':focus': {
      border: '1px solid ' + (props.disabled ? lightestGrey : mediumDarkGrey)
    }
  };
  return style;
});



// WEBPACK FOOTER //
// ./src/styles/LaunchpadButton.js